import React, { useEffect, useRef} from 'react'
import { useParams, Link } from 'react-router-dom'
import { DataSet } from 'vis-data'
import { Network } from 'vis-network'
import axios from 'axios'

import NextComparisonLink from 'components/NextComparisonLink'

function ListAsGraph() {
  const { listId } = useParams()
  const containerRef = useRef(null)

  useEffect( () => {
    axios.get(`/api/lists/${listId}/graph_data`)
      .then( res => {
        const { nodes, edges } = res.data

        const data = {
          nodes: new DataSet(nodes),
          edges: new DataSet(edges),
        }

        const options = {
          edges: { arrows: 'to' },
          layout: { hierarchical: false }
        }

        new Network(containerRef.current, data, options)
      })
  } )

  return (
    <>
      <ul className='list-inline mt-3'>
        <li className='list-inline-item'>
            <li className="list-inline-item">
              <NextComparisonLink listId={listId} setError={e => alert(e)} />
            </li>

            <li className="list-inline-item">
              <Link to={`/lists/${listId}`}>
                View as List
              </Link>
            </li>
        </li>
      </ul>

      <div
        ref={containerRef}
        style={{height: '500px', border: '1px solid black'}}
      />
    </>
  )
}

export default ListAsGraph
